/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_FollowersInputs */

const en_story_followers = /** @type {(inputs: Story_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Followers`)
};

const es_story_followers = /** @type {(inputs: Story_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguidores`)
};

const fr_story_followers = /** @type {(inputs: Story_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnés`)
};

const de_story_followers = /** @type {(inputs: Story_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follower`)
};

const id_story_followers = /** @type {(inputs: Story_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengikut`)
};

/** @type {(inputs: Story_FollowersInputs) => LocalizedString} */
const ja_story_followers = en_story_followers;

/** @type {(inputs: Story_FollowersInputs) => LocalizedString} */
const zh_story_followers = en_story_followers;

/** @type {(inputs: Story_FollowersInputs) => LocalizedString} */
const ar_story_followers = en_story_followers;

/** @type {(inputs: Story_FollowersInputs) => LocalizedString} */
const it_story_followers = en_story_followers;

/** @type {(inputs: Story_FollowersInputs) => LocalizedString} */
const ru_story_followers = en_story_followers;

/** @type {(inputs: Story_FollowersInputs) => LocalizedString} */
const pt_story_followers = en_story_followers;

/** @type {(inputs: Story_FollowersInputs) => LocalizedString} */
const ko_story_followers = en_story_followers;

/**
* | output |
* | --- |
* | "Followers" |
*
* @param {Story_FollowersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_followers = /** @type {((inputs?: Story_FollowersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_FollowersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_followers(inputs)
	if (locale === "es") return es_story_followers(inputs)
	if (locale === "fr") return fr_story_followers(inputs)
	if (locale === "de") return de_story_followers(inputs)
	if (locale === "ja") return ja_story_followers(inputs)
	if (locale === "zh") return zh_story_followers(inputs)
	if (locale === "ar") return ar_story_followers(inputs)
	if (locale === "id") return id_story_followers(inputs)
	if (locale === "it") return it_story_followers(inputs)
	if (locale === "ru") return ru_story_followers(inputs)
	if (locale === "pt") return pt_story_followers(inputs)
	return ko_story_followers(inputs)
});